import VueApexCharts from 'vue-apexcharts'

export default {
  components:{ apexcharts: VueApexCharts }
}
